// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_-bQNm clearfix","box_r":"index_box_r_X6-tm","d_box":"index_d_box_wm3TY"};